import { TableView } from "client/Components";
import { ReactNode } from "react";
import styles from "./UserCollectionCell.module.less";

export type UserCollectionCellProps = {
	children: ReactNode;
	isDeleted?: Date | nil;
	tooltip?: string;
};

export const UserCollectionCell = (props: UserCollectionCellProps) => {
	const {
		isDeleted,
		tooltip,
		children
	} = props;

	return (
		<TableView.Cell tooltip={tooltip}>
			{isDeleted ? (
				<span className={styles.deleted}>{children}</span>
			) :
				children
			}
		</TableView.Cell>
	);
};

UserCollectionCell.displayName = "UserCollectionCell";